/*
  assets/nibec-cotiza-medicion.js · Bigbuda · T-0953 (20-oct-2026)
  Se carga solo en la página de cotización (/pages/contacto; snippets/nibec-cotiza-global.liquid) con «Cotización única».
  No cambia cómo funciona el formulario en 2 pasos (sections/nibec-contacto-form.liquid + assets/nibec-cotizacion-formal.js):
  solo lo MIDE con eventos nuevos y limpios, y agrega el aviso de 90 días para proyectos a medida.

  Eventos (dataLayer y Shopify.analytics.publish; NO marcan conversiones ni tocan Tag Manager):
    cotiza_vista               se ve la página (entrada = ?desde=, items = productos en la lista)
    cotiza_inicio              primera interacción con el formulario (campo)
    cotiza_paso_1              «Continuar» con el paso 1 válido (items, con_detalle)
    cotiza_error               se frenó un envío o un «Continuar» por datos que faltan (paso, campos)
    cotiza_formulario_intento  «Cotizar» con los 2 pasos válidos: el envío sale hacia Shopify (antes del captcha)
    cotiza_formulario_enviado  Shopify aceptó el envío (aparece el mensaje de éxito; una sola vez):
                               tipo_cliente (empresa | persona), items, unidades, comuna, entrada, origen.
                               Es el evento que Fernando y Paulete pueden marcar como generate_lead cuando Marcel avise.
    cotiza_abandono            se fue con el formulario empezado y sin enviar (ultimo_paso)
  Aviso de 90 días (Benjamín, correo del 19-oct): si en lo que escribe aparece altillo, drive-in, cantilever o mezanine, bajo
  la caja sale «Los proyectos a medida… unos 90 días…». Al enviar, la lista de cotización se vacía.
*/
(function () {
  'use strict';
  var form = document.getElementById('contact_form');
  if (!form || form.__ncm) return;
  form.__ncm = true;
  var LISTA = 'nibecCotizacion', ENVIO = 'nibecCotizaEnvio';
  var q = new URLSearchParams(location.search), entrada = (q.get('desde') || '').slice(0, 40) || 'directo';
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function lista() { try { var a = JSON.parse(localStorage.getItem(LISTA) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function unidades(a) { return a.reduce(function (n, i) { return n + (i.q || 0); }, 0); }
  function medir(nombre, d) {
    d = d || {};
    d.dispositivo = window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador';
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, d); } catch (e) {}
    try { var o = { event: nombre }; for (var k in d) o[k] = d[k]; (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {}
  }
  function campoNombre(c) { return ((c && c.name) || '').replace(/^contact\[|\]$/g, '').slice(0, 40); }

  // ── Éxito ──────────────────────────────────────────────────────────────────────────────────────────
  if (form.querySelector('[data-brevo-exito]')) {
    var env = null; try { env = JSON.parse(ss(ENVIO) || 'null'); } catch (e) {}
    if (env && !env.medido && Date.now() - env.hora < 30 * 60 * 1000) {
      medir('cotiza_formulario_enviado', { tipo_cliente: env.tipo_cliente, items: env.items, unidades: env.unidades, comuna: env.comuna, entrada: env.entrada, origen: env.origen });
      env.medido = true; ss(ENVIO, JSON.stringify(env));
      try { localStorage.removeItem(LISTA); document.dispatchEvent(new Event('nibec:lista')); } catch (e) {}
    }
    return;
  }

  // ── Aviso de 90 días ───────────────────────────────────────────────────────────────────────────────
  var caja = form.querySelector('textarea[name="contact[body]"]');
  var aviso = null;
  if (caja) {
    aviso = document.createElement('p');
    aviso.className = 'nibec-contacto__aviso90';
    aviso.setAttribute('role', 'note');
    aviso.hidden = true;
    aviso.textContent = 'Los proyectos a medida (altillos, drive-in y cantilever) se fabrican en el extranjero: el plazo de entrega es de unos 90 días. Te lo confirmamos en la cotización.';
    caja.parentNode.insertBefore(aviso, caja.nextSibling);
    var st = document.createElement('style');
    st.textContent = '.nibec-contacto__aviso90{display:flex;gap:.8rem;margin:1rem 0 0;padding:1.2rem 1.4rem;border-radius:14px;background:#fff7e0;border:1px solid rgba(255,170,0,.55);color:#121212;font-size:14px;line-height:20px}' +
      '.nibec-contacto__aviso90::before{content:"";flex:none;width:18px;height:18px;margin-top:1px;background:no-repeat center/18px url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23121212%27 stroke-width=%272%27 stroke-linecap=%27round%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279%27/%3E%3Cpath d=%27M12 7v5l3 2%27/%3E%3C/svg%3E")}' +
      '.nibec-contacto__aviso90[hidden]{display:none}';
    document.head.appendChild(st);
    var revisar90 = function () { aviso.hidden = !/altillo|drive.?in|cantilever|mezz?anine|mezanine|a medida/i.test(caja.value); };
    caja.addEventListener('input', revisar90); revisar90();
  }

  // ── Embudo ─────────────────────────────────────────────────────────────────────────────────────────
  var empezado = false, paso1 = false, intento = false;
  form.addEventListener('focusin', function (e) {
    if (empezado || !e.target || !/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || e.target.type === 'hidden') return;
    empezado = true; medir('cotiza_inicio', { campo: campoNombre(e.target), items: lista().length, entrada: entrada });
  });
  function erroresVisibles(paso) {
    var bloque = form.querySelector('[data-paso="' + paso + '"]') || form;
    var malos = Array.prototype.map.call(bloque.querySelectorAll('[aria-invalid="true"]'), function (c) { return campoNombre(c) || (c.getAttribute('data-nibec-tipo') !== null ? 'tipo' : c.getAttribute('data-nibec-entrega') !== null ? 'entrega' : 'campo'); });
    // T-1552: los productos son obligatorios; su error vive fuera de los pasos (columna derecha o bloque del formulario) y se cuenta una sola vez por evento.
    if (document.querySelector('.nibec-contacto__error--productos')) malos.push('productos');
    return malos;
  }
  var continuar = form.querySelector('[data-nibec-continuar]');
  if (continuar) continuar.addEventListener('click', function () {
    // nibec-cotizacion-formal.js valida en este mismo clic: se lee el resultado un instante después.
    setTimeout(function () {
      var p2 = form.querySelector('[data-paso="2"]');
      if (p2 && !p2.hidden) {
        if (!paso1) { paso1 = true; medir('cotiza_paso_1', { items: lista().length, con_detalle: !!(caja && caja.value.trim()), entrada: entrada }); }
      } else {
        var malos = erroresVisibles(1); if (malos.length) medir('cotiza_error', { paso: 1, campos: malos.join(','), entrada: entrada });
      }
    }, 0);
  });
  // El envío inválido lo corta nibec-cotizacion-formal.js en la captura de window: este oyente (en el formulario, fase de burbuja) solo
  // corre si el envío siguió adelante.
  form.addEventListener('submit', function () {
    intento = true;
    var a = lista(), tipo = form.querySelector('[data-nibec-tipo] input:checked');
    var comuna = form.querySelector('[data-nibec-comuna]');
    if (comuna && comuna.disabled) comuna = null; // T-1552: con Retiro la comuna no se pide ni viaja
    var datos = {
      tipo_cliente: tipo ? (/empresa/i.test(tipo.value) ? 'empresa' : 'persona') : 'sin dato', items: a.length, unidades: unidades(a),
      comuna: comuna ? comuna.value.trim().slice(0, 40) : '', entrada: entrada, origen: ss('nq_origen') || '', hora: Date.now()
    };
    ss(ENVIO, JSON.stringify(datos));
    medir('cotiza_formulario_intento', { tipo_cliente: datos.tipo_cliente, items: datos.items, unidades: datos.unidades, entrada: entrada });
  });
  // Errores del paso 2 (el envío se frenó): se miran después del clic en «Cotizar».
  var enviar = form.querySelector('button[type="submit"]');
  if (enviar) enviar.addEventListener('click', function () {
    setTimeout(function () { if (intento) return; var malos = erroresVisibles(2).concat(erroresVisibles(1)).filter(function (n, i, t) { return t.indexOf(n) === i; }); if (malos.length) medir('cotiza_error', { paso: 2, campos: malos.join(','), entrada: entrada }); }, 0);
  });
  var abandonoHecho = false;
  function abandono() {
    if (!empezado || intento || abandonoHecho) return;
    abandonoHecho = true; medir('cotiza_abandono', { ultimo_paso: paso1 ? 2 : 1, items: lista().length, entrada: entrada });
  }
  window.addEventListener('pagehide', abandono);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') abandono(); });
  medir('cotiza_vista', { entrada: entrada, items: lista().length, unidades: unidades(lista()) });
})();
